import { useIntl } from '@tink/core/src/components/providers/LanguageProvider/useIntl';
import { Severity } from '@tink/core/src/components/atoms/Icons/AlertIcon';
import { commonMessages } from '../../atoms/CommonMessages/messages';
import { PageView } from '../../../models/analytics';
import { VerboseErrorScreen } from '../VerboseErrorScreen/VerboseErrorScreen';
import { messages } from './messages';

type ProviderTemporaryDisabledProps = {
  onPrimaryClick: () => void;
  onSecondaryClick?: () => void;
};

export const ProviderTemporaryDisabled: React.FC<ProviderTemporaryDisabledProps> = ({
  onPrimaryClick,
  onSecondaryClick,
}) => {
  const { formatMessage } = useIntl();
  const primaryButtonCopy = onSecondaryClick ? messages.selectAnother : commonMessages.ok;

  return (
    <VerboseErrorScreen
      viewEvent={PageView.PROVIDER_TEMPORARY_DISABLED_SCREEN}
      severity={Severity.INFO}
      title={formatMessage(messages.unavailableMessage)}
      body={[{ text: formatMessage(messages.tryAgain) }]}
      primaryAction={onPrimaryClick}
      primaryButtonText={formatMessage(primaryButtonCopy)}
      secondaryAction={onSecondaryClick}
      secondaryButtonText={formatMessage(commonMessages.cancel)}
    />
  );
};
